/* eslint-disable no-prototype-builtins */
import React, { useState } from 'react';
import { FILTER_FIELDS, FILTER_OPTIONS, FILTER_RETAILERS } from '_constants/old/filters';
import { CheckedList } from 'modules/Modals/old/FilterModal/components/CheckboxGroup';
import { CollapsedTab } from 'modules/Modals/old/FilterModal/components/CollapsedTab';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import RadioButtonsOrganizer from 'ui-kit/old/radioButton/radioButtonsOrganizer';
import { FormGroup } from 'modules/Modals/old/FilterModal/components/FormGroup';
import { OldFilterEntity } from '_entities';
import * as Styled from './styles';

const { setShadowFilter } = OldFilterEntity.actions;

function RetailerCharacteristics({ isVaAccount, isResidential, corpOptions, isAzAccount, isMdAccount }) {
  const {
    filter: { shadowFilters },
  } = useSelector((state) => state);
  const dispatch = useDispatch();
  const [atccYear, setAtccYear] = useState(new Date().getFullYear().toString());
  const RETAILER_CHARACTERISTICS_TABS = [
    {
      type: 'multiple',
      title: 'Products sold',
      id: 1,
      collapsed: [
        {
          id: 2,
          title: 'Tobacco',
          field: FILTER_FIELDS.TOBACCO,
          options: FILTER_OPTIONS.SELLS_TOBACCO_OPTIONS,
        },
        {
          id: 3,
          title: 'Sells cigarettes',
          field: FILTER_FIELDS.SELL_CIGARETTES,
          options: FILTER_OPTIONS.SELLS_CIGARETTES_OPTIONS,
          isSubcategory: true,
        },
        {
          id: 4,
          title: 'Sells cigars',
          field: FILTER_FIELDS.SELL_CIGARS,
          options: FILTER_OPTIONS.SELLS_CIGARS_OPTIONS,
          isSubcategory: true,
        },
        {
          id: 5,
          title: 'Sells e-cigarettes',
          field: FILTER_FIELDS.SELL_ECIG,
          options: FILTER_OPTIONS.SELLS_ECIG_OPTIONS,
          isSubcategory: true,
        },
        {
          id: 6,
          title: 'Sells smokeless tobacco products',
          field: FILTER_FIELDS.SELL_SMOKELESS,
          options: FILTER_OPTIONS.SELLS_SMOKELESS_OPTIONS,
          isSubcategory: true,
        },
        {
          id: 7,
          title: 'Alcohol',
          field: FILTER_FIELDS.ALCOHOL,
          options: FILTER_OPTIONS.SELLS_ALCOHOL_OPTIONS,
        },
      ],
    },
    isVaAccount && {
      type: 'multiple',
      title: 'Gambling',
      id: 8,
      collapsed: [
        {
          id: 9,
          title: 'Sells lottery tickets',
          field: FILTER_FIELDS.SELLS_TICKETS,
          options: FILTER_OPTIONS.SELLS_TICKETS_OPTIONS,
        },
        {
          id: 10,
          title: 'Has gaming machines',
          field: FILTER_FIELDS.HAS_GAMING_MACHINES,
          options: FILTER_OPTIONS.HAS_GAMING_MACHINES_OPTIONS,
        },
      ],
    },
    {
      id: 11,
      field: FILTER_FIELDS.RETAILER_BUSINESS_TYPE,
      title: 'Store type',
      options: FILTER_OPTIONS.STORE_TYPE_OPTIONS,
      type: 'single',
    },
    {
      type: 'multiple',
      title: 'Proximity',
      id: 12,
      collapsed: [
        {
          id: 13,
          field: FILTER_FIELDS.NEAR_SCHOOL,
          title: 'Near schools',
          options: FILTER_OPTIONS.NEAR_SCHOOL_OPTIONS,
        },
        {
          id: 14,
          field: FILTER_FIELDS.NEAR_RETAILER,
          title: 'Near retailers',
          options: FILTER_OPTIONS.NEAR_RETAILER_OPTIONS,
        },
      ],
    },
    {
      type: 'double',
      title: 'Other retailer details',
      id: 15,
      collapsed: [
        {
          id: 16,
          field: FILTER_FIELDS.WIC,
          options: FILTER_OPTIONS.WIC_OPTIONS,
        },
        {
          id: 17,
          field: FILTER_FIELDS.SNAP,
          options: FILTER_OPTIONS.SNAP_OPTIONS,
        },
        {
          id: 18,
          field: FILTER_FIELDS.PHARMACY,
          options: FILTER_OPTIONS.HAS_PHARMACY_OPTIONS,
        },
        {
          id: 19,
          field: FILTER_FIELDS.HAS_AVC_AGREEMENT,
          options: FILTER_OPTIONS.HAS_AVC_AGREEMENT_OPTIONS,
        },
        {
          id: 20,
          field: FILTER_FIELDS.INTERNET_SALES_VISTIS,
          options: FILTER_OPTIONS.INTERNET_SALES_OPTIONS,
        },
        isResidential && {
          id: 21,
          field: FILTER_FIELDS.RESIDENTIAL_LOCATION,
          options: FILTER_OPTIONS.RESIDENTIAL_LOCATION_OPTIONS,
        },
      ],
    },
    {
      ...(isAzAccount && {
        type: 'double',
        title: 'Store ownership',
        id: 23,
        collapsed: [
          {
            id: 24,
            field: FILTER_FIELDS.CHAIN,
            options: FILTER_OPTIONS.CHAIN_OPTIONS,
          },
          {
            id: 25,
            field: FILTER_FIELDS.CORPORATION,
            options: corpOptions,
          },
        ],
      }),
    },
  ];

  const filters = {
    [FILTER_FIELDS.ATCC]: null,
  };

  const handleInputChange = (e) => {
    const inputValue = e.target.value;

    const numericValue = inputValue.replace(/\D/g, '').slice(0, 4);

    setAtccYear(numericValue);

    if (numericValue.length === 4) {
      handleChangeFiltersAtccYear(FILTER_FIELDS.ATCC, { value: numericValue });
    }
  };

  const RADIO_BUTTONS = [
    {
      value: FILTER_RETAILERS.ATCC_OPTIONS.OPTION_IS_ATCC,
      checked: shadowFilters[FILTER_FIELDS.ATCC] === 't',
    },
    {
      value: FILTER_RETAILERS.ATCC_OPTIONS.OPTION_ATCC_CERTAIN_YEAR,
      checked: shadowFilters[FILTER_FIELDS.ATCC] === atccYear,
      customComponent: (
        <Styled.TextInputContainer>
          <Styled.TextInputLabel htmlFor="year-input" />
          <Styled.TextInput
            id="year-input"
            type="text"
            value={atccYear}
            onChange={handleInputChange}
            placeholder={atccYear}
            maxLength={4}
          />
        </Styled.TextInputContainer>
      ),
    },
    {
      value: FILTER_RETAILERS.ATCC_OPTIONS.OPTION_NOT_ATCC,
      checked: shadowFilters[FILTER_FIELDS.ATCC] === 'f',
    },
  ];

  const getElement = (item) => {
    switch (item.type) {
      case 'single':
        return (
          <CollapsedTab title={item.title} key={item.id}>
            <CheckedList name={item.field} options={item.options} />
          </CollapsedTab>
        );
      case 'multiple':
        return (
          <CollapsedTab title={item.title} key={item.id}>
            {item.collapsed.map((elem) => (
              <Styled.FiltersContainer>
                <Styled.FiltersTitle isSubcategory={elem?.isSubcategory}>{elem.title}</Styled.FiltersTitle>
                <CheckedList name={elem.field} options={elem.options} isSubcategory={elem?.isSubcategory} />
              </Styled.FiltersContainer>
            ))}
          </CollapsedTab>
        );
      case 'double':
        return (
          <CollapsedTab title={item.title} key={item.id}>
            {item.collapsed.map((elem) => (
              <CheckedList name={elem.field} options={elem.options} />
            ))}
          </CollapsedTab>
        );
      default:
        return null;
    }
  };

  const handleChangeFiltersAtccYear = (field, { value }) => {
    const newFilters = { ...shadowFilters };
    switch (field) {
      case FILTER_FIELDS.ATCC:
        dispatch(
          setShadowFilter({
            ...newFilters,
            ...{ [FILTER_FIELDS.ATCC]: value },
          }),
        );
        break;
      default:
        break;
    }
  };

  const handleRadioButton = (value) => {
    switch (value) {
      case FILTER_RETAILERS.ATCC_OPTIONS.OPTION_IS_ATCC:
        filters[FILTER_FIELDS.ATCC] = 't';
        break;
      case FILTER_RETAILERS.ATCC_OPTIONS.OPTION_ATCC_CERTAIN_YEAR:
        filters[FILTER_FIELDS.ATCC] = atccYear;
        break;
      case FILTER_RETAILERS.ATCC_OPTIONS.OPTION_NOT_ATCC:
        filters[FILTER_FIELDS.ATCC] = 'f';
        break;
      default:
        break;
    }
    dispatch(setShadowFilter({ ...shadowFilters, ...filters }));
  };

  return (
    <Styled.Wrapper>
      {RETAILER_CHARACTERISTICS_TABS.map((item) => getElement(item))}{' '}
      {isMdAccount && (
        <FormGroup title="ATCC">
          <RadioButtonsOrganizer
            hideResetButton
            radioButtons={RADIO_BUTTONS}
            onChange={({ value }) => handleRadioButton(value)}
            name="atcc"
            isColumn
          />
        </FormGroup>
      )}
    </Styled.Wrapper>
  );
}

RetailerCharacteristics.propTypes = {
  isVaAccount: PropTypes.bool,
  isMdAccount: PropTypes.bool,
  isAzAccount: PropTypes.bool,
  isResidential: PropTypes.bool,
  corpOptions: PropTypes.array,
};

RetailerCharacteristics.defaultProps = {
  isVaAccount: false,
  isMdAccount: false,
  isAzAccount: false,
  isResidential: false,
  corpOptions: [],
};

export default RetailerCharacteristics;
